import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/auth/authentication.service';
import { RedirectRouterService } from '@shared/services/web/redirect-router.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login-hash',
  templateUrl: './login-hash.component.html',
  styleUrls: ['./login-hash.component.scss'],
})
export class LoginHashComponent implements OnInit, OnDestroy {
  finishLoad = '';
  messageError = '';
  private $destroyList = new Subject<void>();
  $requestDataSubject = new Subject<void>();
  constructor(
    private route: ActivatedRoute,
    private authenticationSvc: AuthenticationService,
    private redirectService: RedirectRouterService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      if (res.hash) {
        this.loginWithHash(res.hash);
      }
    });
  }

  loginWithHash(hash: string) {
    this.$requestDataSubject.next();
    this.$destroyList.next();
    this.authenticationSvc
      .loginWithHash(hash)
      .pipe(takeUntil(this.$destroyList))
      .subscribe({
        next: (res: any) => {
          this.finishLoad = 'success';
        },
        error: (err: any) => {
          this.finishLoad = 'error';
          this.messageError = err.error.message;
        },
      });
  }

  ngOnDestroy(): void {
    this.$destroyList.next();
    this.$destroyList.complete();
  }

  gotoHome() {
    this.redirectService.goToPage('/');
  }
}
